import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

const CATEGORIES: Record<string, string> = {
  general: 'Ерөнхий', maintenance: 'Засвар', billing: 'Төлбөр',
  event: 'Арга хэмжээ', rule_change: 'Дүрмийн өөрчлөлт', emergency: 'Онцгой',
};
const PRIORITIES: Record<string, string> = {
  low: 'Бага', normal: 'Энгийн', high: 'Өндөр', urgent: 'Яаралтай',
};
const PRIO_COLORS: Record<string, string> = {
  low: '#6b7280', normal: '#236844', high: '#f59e0b', urgent: '#ef4444',
};

interface AnnForm {
  title: string; content: string; category: string; priority: string;
  is_pinned: boolean; is_published: boolean;
}
const emptyForm: AnnForm = {
  title: '', content: '', category: 'general', priority: 'normal',
  is_pinned: false, is_published: true,
};

export default function AnnouncementsPage() {
  const [items, setItems] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState<string | null>(null);
  const [form, setForm] = useState<AnnForm>(emptyForm);

  const load = () => {
    setLoading(true);
    const params = filter ? `?category=${filter}` : '';
    api.get(`/admin/announcements${params}`)
      .then(data => { setItems(data?.items || []); setTotal(data?.total || 0); })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, [filter]);

  const handleSubmit = async () => {
    try {
      if (editId) {
        await api.put(`/admin/announcements/${editId}`, form);
      } else {
        await api.post('/admin/announcements', form);
      }
      setShowForm(false); setEditId(null); setForm(emptyForm); load();
    } catch { /* ignore */ }
  };

  const handleDelete = async (id: string) => {
    if (!window.confirm('Устгах уу?')) return;
    try { await api.delete(`/admin/announcements/${id}`); load(); } catch {}
  };

  const togglePublish = async (a: any) => {
    try {
      await api.put(`/admin/announcements/${a.id}`, { is_published: !a.is_published });
      load();
    } catch {}
  };

  const openEdit = (a: any) => {
    setEditId(a.id);
    setForm({
      title: a.title, content: a.content, category: a.category,
      priority: a.priority, is_pinned: a.is_pinned, is_published: a.is_published,
    });
    setShowForm(true);
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 style={{ fontFamily: "'Inter'", fontWeight: 700, fontSize: 24, color: '#1c2b22', margin: 0 }}>
          Зарлал мэдэгдэл ({total})
        </h2>
        <button onClick={() => { setEditId(null); setForm(emptyForm); setShowForm(true); }} style={btnPrimary}>
          + Шинэ зарлал
        </button>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        <button onClick={() => setFilter('')} style={filterBtn(!filter)}>Бүгд</button>
        {Object.entries(CATEGORIES).map(([k, v]) => (
          <button key={k} onClick={() => setFilter(k)} style={filterBtn(filter === k)}>{v}</button>
        ))}
      </div>

      {loading ? <p style={{ color: '#5f6f66' }}>Уншиж байна...</p> : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {items.map(a => (
            <div key={a.id} style={{
              background: '#fff', borderRadius: 12, padding: 20,
              boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
              borderLeft: `4px solid ${PRIO_COLORS[a.priority] || '#236844'}`,
              opacity: a.is_published ? 1 : 0.6,
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                    {a.is_pinned && <span>📌</span>}
                    <strong style={{ fontSize: 17, color: '#1c2b22' }}>{a.title}</strong>
                    {!a.is_published && <span style={{ fontSize: 11, background: '#fef3c7', color: '#92400e', padding: '2px 8px', borderRadius: 10 }}>Нуугдсан</span>}
                  </div>
                  <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                    <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 10, background: '#f0f9f4', color: '#236844' }}>
                      {CATEGORIES[a.category] || a.category}
                    </span>
                    <span style={{
                      fontSize: 11, padding: '2px 8px', borderRadius: 10,
                      background: `${PRIO_COLORS[a.priority] || '#236844'}15`,
                      color: PRIO_COLORS[a.priority] || '#236844', fontWeight: 600,
                    }}>
                      {PRIORITIES[a.priority] || a.priority}
                    </span>
                  </div>
                  <p style={{ color: '#374151', fontSize: 14, margin: 0, whiteSpace: 'pre-wrap' }}>
                    {a.content.length > 200 ? a.content.slice(0, 200) + '...' : a.content}
                  </p>
                  <div style={{ display: 'flex', gap: 16, marginTop: 10, fontSize: 12, color: '#94a3b8' }}>
                    <span>{a.created_at ? new Date(a.created_at).toLocaleDateString('mn-MN') : ''}</span>
                    <span>Уншсан: {a.view_count}</span>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                  <button onClick={() => togglePublish(a)} style={smallBtn}>
                    {a.is_published ? 'Нуух' : 'Нийтлэх'}
                  </button>
                  <button onClick={() => openEdit(a)} style={smallBtn}>Засах</button>
                  <button onClick={() => handleDelete(a.id)} style={{ ...smallBtn, color: '#ef4444', background: '#fef2f2' }}>Устгах</button>
                </div>
              </div>
            </div>
          ))}
          {items.length === 0 && (
            <div style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>Зарлал олдсонгүй</div>
          )}
        </div>
      )}

      {showForm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
          onClick={() => setShowForm(false)}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 32, width: 560, maxHeight: '85vh', overflow: 'auto' }}
            onClick={e => e.stopPropagation()}>
            <h3 style={{ fontFamily: "'Inter'", fontWeight: 700, fontSize: 20, color: '#1c2b22', marginTop: 0 }}>
              {editId ? 'Зарлал засах' : 'Шинэ зарлал'}
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div>
                <label style={labelStyle}>Гарчиг</label>
                <input value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} style={inputStyle} placeholder="Зарлалын гарчиг" />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div>
                  <label style={labelStyle}>Ангилал</label>
                  <select value={form.category} onChange={e => setForm({ ...form, category: e.target.value })} style={inputStyle}>
                    {Object.entries(CATEGORIES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Яаралтай байдал</label>
                  <select value={form.priority} onChange={e => setForm({ ...form, priority: e.target.value })} style={inputStyle}>
                    {Object.entries(PRIORITIES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                </div>
              </div>
              <div>
                <label style={labelStyle}>Агуулга</label>
                <textarea value={form.content} onChange={e => setForm({ ...form, content: e.target.value })} rows={6} style={{ ...inputStyle, resize: 'vertical' }} placeholder="Зарлалын агуулга..." />
              </div>
              <div style={{ display: 'flex', gap: 20 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 14 }}>
                  <input type="checkbox" checked={form.is_pinned} onChange={e => setForm({ ...form, is_pinned: e.target.checked })} />
                  Бэхлэх
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 14 }}>
                  <input type="checkbox" checked={form.is_published} onChange={e => setForm({ ...form, is_published: e.target.checked })} />
                  Нийтлэх
                </label>
              </div>
              <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
                <button onClick={() => setShowForm(false)} style={{ padding: '10px 20px', border: '1px solid #d1d5db', borderRadius: 8, background: '#fff', cursor: 'pointer' }}>Цуцлах</button>
                <button onClick={handleSubmit} disabled={!form.title.trim() || !form.content.trim()} style={{ ...btnPrimary, opacity: form.title.trim() && form.content.trim() ? 1 : 0.5 }}>
                  {editId ? 'Хадгалах' : 'Нийтлэх'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function filterBtn(active: boolean): React.CSSProperties {
  return {
    padding: '6px 14px', borderRadius: 20, border: 'none', cursor: 'pointer', fontSize: 13,
    background: active ? '#236844' : '#e8e5dc', color: active ? '#fff' : '#5f6f66', fontWeight: active ? 600 : 400,
  };
}
const btnPrimary: React.CSSProperties = {
  background: 'linear-gradient(180deg, #2f7d52, #236844)', color: '#fff', border: 'none',
  padding: '10px 20px', borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14, fontFamily: "'Inter'",
};
const smallBtn: React.CSSProperties = {
  background: '#f0f9f4', border: 'none', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', color: '#236844', fontSize: 12,
};
const labelStyle: React.CSSProperties = { display: 'block', marginBottom: 4, fontSize: 13, color: '#374151', fontWeight: 500 };
const inputStyle: React.CSSProperties = {
  width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box',
};
